<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2"
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-container fluid style="margin-top:-20px">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title v-if="tenant == 'sbpps'">Parent-School Communication</v-toolbar-title>
                    <v-toolbar-title v-else>Student's Diary</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
                            item-text="learner" item-value="id" label="Child" outlined persistent-hint
                            hint="Please Select Child" />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Message Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="diary_message_type"
                            :items="diary_message_type_list" item-text="name" item-value="id" label="Message Type"
                            outlined persistent-hint hint="Please Select Message Type" />
                    </v-col>
                    <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.ay && this.child">
                        <v-btn color="brand onBrand--text" @click="getParentDairy()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-row justify="center" dense v-if="child && ay">
                <v-btn class="button" @click="dialog_compose_message = true" dense>Compose Message</v-btn>
            </v-row>
            <br />
            <v-card class="box" v-if="diary_data != ''">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>
                        Student`s Diary | AY:{{ cay }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field class="white" v-model="search" append-icon="search" label="Search in table" rounded
                        single-line hide-details></v-text-field>

                </v-toolbar>
                <v-card-text>
                    <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search"
                        :items="diary_data" :items-per-page="-1" fixed-header>
                        <template v-slot:[`item.diarymessagetype`]="{ item }">
                            <v-chip :color="getColor(item.diarymessagetype)">
                                {{ item.diarymessagetype }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.message`]="{ item }">
                            <v-icon color="blue" @click="showDairy(item)">mdi-eye</v-icon>
                        </template>
                        <template v-slot:[`item.attachment`]="{ item }">
                            <a v-if="item.attachment_file_name != null" target="_blank"
                                :href="awspath + item.attachment_file_path + item.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                        </template>
                        <template v-slot:[`item.url`]="{ item }">
                            <a v-if="item.url" :href="item.url" target="_blank">{{ item.url }}</a>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <span v-if="item.diarymessagetype == 'School to Parent'">
                                --
                                <!-- <v-icon>mdi-alert-circle-outline</v-icon> -->
                            </span>
                            <span v-else>
                                <v-icon color="red" @click="deleteDairy(item)">mdi-trash-can</v-icon>

                            </span>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-dialog v-model="msg_dialog" v-if="msg_data != null" max-width="1200px">
                <v-card>
                    <v-toolbar flat class="toolbar">
                        <v-card-title>Message [{{ msg_data.diarymessagetype }}]</v-card-title>
                    </v-toolbar>
                    <v-card-text>
                        <!-- {{ msg_data }} -->
                        <v-card class="box">
                            <v-row justify="center">
                                <v-col sm="3" md="3">
                                    Post date : <b>{{ msg_data.post_date }}</b>
                                </v-col>
                                <v-col sm="3" md="3">
                                    Faculty : <b>{{ msg_data.instructor }}</b>
                                </v-col>
                                <v-col sm="3" md="3">
                                    Student : <b>{{ msg_data.learner }}</b>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="3" md="3">
                                    Standard : <b>{{ msg_data.learner_std }}</b>
                                </v-col>
                                <v-col sm="3" md="3">
                                    Div : <b>{{ msg_data.learner_div }}</b>
                                </v-col>
                                <v-col sm="3" md="3">
                                    Roll No : <b>{{ msg_data.learner_roll }}</b>
                                </v-col>
                            </v-row>

                            <v-row justify="center">
                                <v-col sm="9" md="9">
                                    Subject :
                                    <v-text-field style="font-weight:bold" outlined v-model="msg_data.subject"
                                        variant="outlined" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row justify="center">
                                <v-col sm="9" md="9">
                                    Message :
                                    <v-textarea style="font-weight:bold" outlined name="input-9-6"
                                        v-model="msg_data.msg" variant="outlined" readonly></v-textarea>


                                    <!-- <div style="border: 1;" v-html="msg_data.msg"></div> -->
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="9" md="9" v-if="msg_data.url">
                                    URL :
                                    <a :href="msg_data.url" target="_blank">{{ msg_data.url }}</a>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col sm="3" md="3" v-if="msg_data.isread == true">
                                    Read On : <b>{{ msg_data.read_date }}</b>
                                </v-col>

                                <v-col sm="3" md="3" v-if="msg_data.attachment_file_name != null">
                                    Attachment : <a target="_blank"
                                        :href="awspath + msg_data.attachment_file_path + msg_data.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn color="warning"
                            @click="msg_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_compose_message" style="margin-top: 10%" fullscreen hide-overlay
                transition="dialog-top-transition">
                <v-card class="mx-auto">
                    <v-toolbar dark color="brand onBrand--text">
                        <v-toolbar-title>Compose Message</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text
                                @click="dialog_compose_message = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <br />
                    <v-card-text>
                        <v-card class="box">
                            <!-- <v-row justify="center" dense>
                             <v-col cols="12" sm="3" v-if="stud_list!=''">
                                <p><v-icon color="error">*</v-icon><b>Select Student</b></p>
                                <v-autocomplete
                                color="#0F2027"
                                dense
                                rounded
                                required
                                v-model="learners"
                                :items="child_list"
                                item-text="stud"
                                item-value="ld_id"
                                label="Student"
                                outlined
                                persistent-hint
                                hint="Please Select Student"
                                multiple
                                />
                            </v-col>
                  </v-row> -->

                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><v-icon color="error">*</v-icon><b>Subject</b></p>
                                    <v-text-field outlined v-model="subject"
                                        label="Enter Message Subject"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><v-icon color="error">*</v-icon><b>Description</b></p>
                                    <v-textarea outlined name="input-7-4" v-model="description"
                                        label="Enter Message Description"></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><b>URL (Optional)</b></p>
                                    <v-text-field outlined v-model="url" label="Enter URL" placeholder="https://example.com"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="5" md="5">
                                    <p><b>Attachment If Any</b></p>
                                    <v-file-input rounded dense outlined prepend-icon="mdi-attachment"
                                        label="Choose File" show-size v-model="file" name="doc"></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense v-if="child && ay && description && subject">
                                <v-btn class="mt-5 pt-0 button" @click="addDiary()" dense :loading="loader">Send</v-btn>
                            </v-row>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-dialog>

        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Student's Diary Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/iEHUvjphAzE?si=fUjxgE1TrfXtQP-S"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        dialog_compose_message: false,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        loader: false,
        snackbar_msg: "",
        videoDialog:false,
        color: "",
        snackbar: false,
        overlay: false,
        awspath: null,
        ay_list: [],
        ay: "",
        child_list: [],
        child: "",
        file: null,
        url: "",
        aws_path: null, diary_message_type_list: [], diary_message_type: "", diary_data: [],
        search: '',
        msg_dialog: false, cay: null, description: "", loader: false, subject: "",
        msg_data: null,
        headers: [
            {
                text: "Sr. No.",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Post Date",
                align: "left",
                sortable: false,
                value: "post_date",
            },
            {
                text: "Message Type",
                align: "left",
                sortable: false,
                value: "diarymessagetype",
            },
            {
                text: "Subject",
                align: "left",
                sortable: false,
                value: "subject",
            },
            {
                text: "Message",
                align: "left",
                sortable: false,
                value: "message",
            },
            {
                text: "Attachment",
                align: "left",
                sortable: false,
                value: "attachment",
            },
            {
                text: "URL",
                align: "left",
                sortable: false,
                value: "url",
            },
            // {
            //     text: "From",
            //     align: "left",
            //     sortable: false,
            //     value: "instructor",
            // },
            // {
            //     text: "To",
            //     align: "left",
            //     sortable: false,
            //     value: "learner",
            // },
            // {
            //     text: "Instructor",
            //     align: "left",
            //     sortable: false,
            //     value: "instructor",
            // },
            {
                text: "Read On",
                align: "left",
                sortable: false,
                value: "read_date",
            },
            {
                text: "Action",
                align: "left",
                sortable: false,
                value: "action",
            },
        ],
        tenant: null
    }),
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    methods: {
        async addDiary() {
            let formData = new FormData();
            if (this.child == null || this.child == "") {
                this.showSnackbar("red", "Please select Child...");
                return
            }
            formData.append("attachment_file", this.file);
            formData.append("learners", this.child);
            formData.append("description", this.description);
            formData.append("subject", this.subject);
            formData.append("url", this.url);
            formData.append("ay", this.ay);
            formData.append("from", "PTT");
            this.overlay = true;
            this.loader = true;
            try {
                const res = await axios.post("/dairy/addDiary", formData)
                if (res.data.flag == "YES") {
                    this.stud_list = res.data.stud_list
                    this.diary_data = res.data.diary_data
                    this.showSnackbar("green", res.data.snackbar);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                this.loader = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
                this.dialog_compose_message = false,
                    this.description = "",
                    this.subject = "",
                    this.url = "";
                    this.file = null,
                    //this.getTeacherDairy();
                    this.loader = false;
            }
        },
        async getParentDairy() {
            this.diary_data = []
            // if(this.diary_message_type==null || this.diary_message_type==''){
            //      this.showSnackbar("red", "Please Select Message Type");
            //      return
            // }
            const formdata = {
                ay: this.ay,
                msg_type: this.diary_message_type,
                learner: this.child,
                diary_id: sessionStorage.getItem("diary_id") || null,
            }
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/getParentDairy", formdata)
                if (res.data.flag == "YES") {
                    this.diary_data = res.data.diary_data
                    this.showSnackbar("green", res.data.snackbar);
                    sessionStorage.removeItem("diary_id");
                    sessionStorage.removeItem("selected_ay");
                    sessionStorage.removeItem("selected_learner");
                    sessionStorage.removeItem("selected_diarymessagetype");
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }

        },
        async showDairy(item) {
            const formdata = {
                diary_id: item.dairy_id
            }
            //call api if message id from parent
            if (item.diarymessagetype == "School to Parent" && item.isread == false) {
                this.overlay = true;
                try {
                    const res = await axios.post("/dairy/readTeacherDairy", formdata)
                    if (res.data.flag == "YES") {
                        item.read_date = res.data.read_date
                        item.isread = true
                        this.showSnackbar("green", res.data.snackbar);
                        this.msg_data = item
                        this.msg_dialog = true
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                }
                catch (err) {
                    console.log("err", err)
                    this.onerror(err);
                    this.overlay = false;
                }
                finally {
                    console.log("bye...")
                    this.overlay = false;
                }
            }
            else {
                this.msg_data = item
                this.msg_dialog = true
            }
        },
        getColor(diarymessagetype) {
            if (diarymessagetype == "Parent to School")
                return "#A1C2F1"
            else
                return "#E1AEFF"
        },
        async deleteDairy(item) {
            const formdata = {
                dairy_id: item.dairy_id
            }
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/deleteParentDairy", formdata)
                if (res.data.flag == "YES") {
                    var index = this.diary_data.indexOf(item)
                    this.diary_data.splice(index, 1)
                    this.showSnackbar("green", res.data.snackbar);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            }
            catch (err) {
                console.log("err", err)
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                console.log("bye...")
                this.overlay = false;
            }

        },
        // onLoad() {
        //     axios
        //         .post("Dairy/getStudentDiary")
        //         .then((res) => {
        //             if (res.data.flag == "YES") {
        //                 (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
        //                 this.child_list = res.data.learner_list;
        //                 // this.child = this.child_list[0];
        //                 this.diary_message_type_list = res.data.diary_message_type_list;
        //                 this.diary_message_type = this.diary_message_type_list[0].id;
        //                 this.overlay = false;
        //                 // this.ay = res.data.curreny_ay;
        //                 this.cay = res.data.cay
        //             } else {
        //                 this.showSnackbar("#b71c1c", res.data.status_reason);
        //             }
        //         })
        //         .catch((error) => {
        //             this.showSnackbar("#b71c1c", "Something went wrong!!!");
        //             this.overlay = false;
        //         })
        //         .finally(() => {
        //             this.overlay = false;
        //         });
        // },
        async onLoad() {
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/getStudentDiary");
                if (res.data.flag == "YES") {
                    this.ay_list = res.data.ay_list;
                    this.ay = res.data.curreny_ay;
                    this.child_list = res.data.learner_list;
                    this.diary_message_type_list = res.data.diary_message_type_list;
                    this.diary_message_type = this.diary_message_type_list[0].id;
                    this.cay = res.data.cay;
                    // Added: Retrieve filter values from sessionStorage
                    const selectedAy = sessionStorage.getItem("selected_ay");
                    const selectedLearner = sessionStorage.getItem("selected_learner");
                    const selectedDiaryMessageType = sessionStorage.getItem("selected_diarymessagetype");
                    // Added: Validate and set filter values
                    if (selectedAy) {
                        const ayValue = JSON.parse(selectedAy);
                        // Validate ay against ay_list
                        const validAy = this.ay_list.find(item => item.id == ayValue);
                        this.ay = validAy ? validAy : res.data.curreny_ay;
                    } else {
                        this.ay = res.data.curreny_ay;
                    }
                    if (selectedLearner) {
                        const learnerValue = JSON.parse(selectedLearner);
                        // Modified: Ensure child is set to the learner ID directly
                        const validLearner = this.child_list.find(item => item.id == learnerValue);
                        if (validLearner) {
                            this.child = validLearner.id; // Set to ID for v-autocomplete
                            console.log("Set child to:", this.child); // Debug log
                        } else {
                            console.log("Invalid learner ID:", learnerValue); // Debug log
                            this.child = this.child_list.length > 0 ? this.child_list[0].id : null;
                        }
                    } else {
                        this.child = this.child_list.length > 0 ? this.child_list[0].id : null;
                    }
                    if (selectedDiaryMessageType) {
                        const msgTypeValue = JSON.parse(selectedDiaryMessageType);
                        // Validate message type against diary_message_type_list
                        const validMsgType = this.diary_message_type_list.find(item => item.id == msgTypeValue);
                        this.diary_message_type = validMsgType ? validMsgType.id : null;
                    } else {
                        this.diary_message_type = null; // Allow null to fetch all message types
                    }
                    if (sessionStorage.getItem("diary_id") && this.ay && this.child) {
                        console.log("Fetching diary with filters:", {
                            ay: this.ay,
                            child: this.child,
                            diary_message_type: this.diary_message_type,
                            diary_id: sessionStorage.getItem("diary_id")
                        }); // Debug log
                        await this.getParentDairy();
                    }
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                    this.overlay = false;
                }
            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            } finally {
                this.overlay = false;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

    mounted() {
        this.onLoad();
        this.tenant = localStorage.getItem("EPS-tenant");
    },
    created() {
        this.awspath = localStorage.getItem('awspath')
    },
    watch: {},
};
</script>
<style scoped>
.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

sub-row {
    border: 2px solid #424093;
    margin: 1rem;
    border-radius: 5px;
}

i {
    font-size: 20px !important;
}

.v-card__title {
    border: 1px solid #80808040;
    font-weight: bold;
    background-color: #424093;
    color: white;
    text-align: center;
    /* margin-top: 1.5rem; */
}

.card-border {
    border: 2px solid darkblue;
    border-radius: 10px;
    /* padding: 5px; */
    /* margin: 1rem !important; */
    width: auto;
}

.tx-bold {
    font-weight: bold;
    font-size: 14px;
    color: black;
}

i {
    font-size: 26px;
    cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #424093 !important;
    color: white !important;
    margin-top: 2.35rem;
    border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: auto;
}

v-simple-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: auto;
    border: 1px solid #ddd;
}

th {
    color: white;
    font-weight: bold;
    text-align: center !important;
}

td,
th {
    padding: 6px;
    border: 1px solid #ccc;
    text-align: center;
}

@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

@media all and (min-width: 1000px) {
    .padding-metting {
        padding-right: 22px;
    }
}

@media (min-width: 320px) and (max-width: 350px) {
    .padding-bot {
        font-size: 11.6px;
    }
}

@media (min-width: 1000px) and (max-width: 1050px) {
    .padding-bot {
        font-size: 9.6px;
    }
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.note-list {
    background-color: orange;
}
</style>
